//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
interface LoadingMaskContextType {
  addLoadingMask: (params: { show: boolean }) => void;
}
interface LoadingMaskProviderType {
  children: React.ReactNode;
}
const LoadingMask = ({ display }: { display: boolean }) => {
  const { t } = useTranslation();
  return (
    <div>
      {display && (
        <div className="fixed bottom-0 w-full h-full bg-gray-300 bg-opacity-50 z-[1001]">
          <div className="flex flex-col items-center absolute inset-1/2">
            <div className="rounded-full border-white border-4 h-16 w-16">
              <div className="relative -top-1 -left-1 border-t-transparent border-solid animate-spin rounded-full border-gray-600 border-4 h-16 w-16"></div>
            </div>
            <div className="w-max">{t('component.loading')}</div>
          </div>
        </div>
      )}
    </div>
  );
};

const LoadingMaskContext = React.createContext<LoadingMaskContextType>(null!);

export const LoadingMaskProvider = ({ children }: LoadingMaskProviderType) => {
  const [status, setStatus] = useState<boolean>(false);
  const addLoadingMask = ({ show = false }: { show: boolean }) => {
    setStatus(show);
  };
  return (
    <LoadingMaskContext.Provider value={{ addLoadingMask }}>
      {children}
      <LoadingMask display={status}></LoadingMask>
    </LoadingMaskContext.Provider>
  );
};

export const useLoadingMask = () => React.useContext(LoadingMaskContext);
